import React from 'react';
import SVG from 'react-inlinesvg';
import { credentials } from '@shootsta/client-auth';
import { replaceBucketKeysWithUrls } from '@shootsta/client-aws-s3';

import { Text, Link, Icon, FormModal } from '../../../ui-kit';
// eslint-disable-next-line import/named
import { LaptopImage } from '../../../assets/images';
import LoggedUser from './LoggedUser';
import { APP_PROTOCOL } from '../constants/links';

import '../styles/_launch-cast-page.scss';
















const LAUNCH_TIMEOUT = 5000;

export default class LaunchCastModal extends
React.Component {
  launchTimer = null;

  constructor() {
    super();

    const { email, imageUrl, firstName } = credentials.get().user;

    this.state = {
      email,
      imageUrl,
      firstName
    };
  }

  async componentDidMount() {
    const { isMobile } = this.props;

    if (isMobile) {
      return;
    }

    window.addEventListener('blur', this.onWindowBlur);

    this.launchTimer = setTimeout(() => {
      this.onToggleDownloadCastAppModal(true);
    }, LAUNCH_TIMEOUT);

    this.onLaunchApp();

    await this.getPreSignedImageUrl();
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.onWindowBlur);
  }

  onWindowBlur = () => {
    clearTimeout(this.launchTimer);
    this.launchTimer = null;
  };

  onToggleDownloadCastAppModal = (isModalClosedWithTimer) => {
    const { onClose } = this.props;

    onClose(isModalClosedWithTimer);
  };

  onCloseModal = () => {
    this.onWindowBlur();
    this.onToggleDownloadCastAppModal(false);
  };

  getPreSignedImageUrl = async () => {
    const { organisationId, apolloClient } = this.props;
    const { imageUrl } = this.state;

    const { imageUrl: preSignedImageUrl } = await replaceBucketKeysWithUrls({
      apiClient: apolloClient,
      data: { imageUrl },
      substitutedKeys: ['imageUrl'],
      organisationId
    });

    this.setState({ imageUrl: preSignedImageUrl });
  };

  onLaunchApp = () => {
    window.open(APP_PROTOCOL, '_self');
  };

  render() {
    const {
      email,
      imageUrl,
      firstName
    } = this.state;

    const { history, isVisible, isMobile } = this.props;

    const renderMobileView = () =>
    <div className="launch-cast-page__inner">
        <div className="launch-cast-page__inner-image">
          <Icon name="castfull" size={100} />
        </div>

        <Text className="launch-cast-page__inner-header" heading3>
          Looks like you&apos;re on a mobile device.
        </Text>

        <Text className="launch-cast-page__inner-subheader" subtitle noMargin="bottom">
          This feature isn&apos;t available for mobile browsers.
          For full functionality, switch to desktop.
        </Text>
      </div>;


    const renderDesktopView = () =>
    <>
        <div className="launch-cast-page__inner">
          <Icon className="launch-cast-page__inner-logo" name="shootstacolour" />

          <div className="launch-cast-page__inner-image">
            <SVG cacheRequests src={LaptopImage} uniquifyIDs />
          </div>

          <Text className="launch-cast-page__inner-header" heading3>
            We&apos;re signing you into Cast...
          </Text>

          <Text className="launch-cast-page__inner-subheader" subtitle noMargin="bottom">
            If a system dialog prompts you, choose the option
            to allow opening Shootsta Cast. If you don&apos;t see a dialog and are not
            automatically logged into Cast,

            <strong>
              <Link button onClick={this.onLaunchApp}>
                click here
              </Link>
            </strong>
            .
          </Text>
        </div>

        <LoggedUser
        email={email}
        imageUrl={imageUrl}
        firstName={firstName}
        history={history} />

      </>;


    return (
      <>
        <FormModal
          visible={isVisible}
          showCancelBtn={false}
          onClose={this.onCloseModal}>

          <div className="launch-cast-page">
            {isMobile ?
            renderMobileView() :
            renderDesktopView()}

          </div>
        </FormModal>
      </>);

  }
}